export default __webpack_public_path__ + "static/media/american-express.6d5209fd.svg";